var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-fluid section-xl"},[_c('div',{staticClass:"grid-wrapper"},[_c('div',{ref:"bannerList",staticClass:"vertical-list",style:(_vm.bannerListStyle)},[_vm._l((_vm.itemsToShow),function(item,index){return [_vm._t("item",null,null,{ key: index, value: item })]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }